<script setup lang="ts">
import { APP_ERROR_ILLUSTRATION_NOT_FOUND_OR_API } from '~/composables/ui/useAppError'

defineProps<{
  canEditOrganigramOnCurrentView: boolean
}>()
</script>

<template>
  <Transition name="empty-encart" appear>
    <div key="direction-empty-encart" class="direction-empty-encart-root">
      <div class="direction-empty-panel">
        <div class="direction-empty-panel__illu" aria-hidden="true">
          <img
            class="direction-empty-panel__img"
            :src="APP_ERROR_ILLUSTRATION_NOT_FOUND_OR_API"
            alt=""
            width="360"
            height="270"
            decoding="async"
          >
        </div>
        <div class="direction-empty-panel__body">
          <h1 class="direction-empty-panel__title">Aucun domaine ni agence pour l’instant</h1>
          <p v-if="canEditOrganigramOnCurrentView" class="direction-empty-panel__hint">
            Activez le <strong>mode édition</strong> pour ajouter domaines, agences, équipes et CODIR.
          </p>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/orga/direction-empty-encart" as *;
</style>
